import { QueryBuilderContext } from './QueryBuilderStoreContext';

export const useQueryBuilderStore = QueryBuilderContext.useStore;
